import 'reflect-metadata'
import {inject, injectable} from 'inversify'
import {makeAutoObservable, observable, action} from 'mobx'
import { error } from 'dna-common'
import {storage} from '@/services/storage'
import {ROUTES} from '@/router/routes'
import {getRouterStore} from '@/router/utils'
import {openErrorNotification} from '@/utils'
import {SIGNUP_STORAGE_KEYS} from '../constants'
import {validateEmailOtp} from '../api'
import {ValidateEmailStoreSymbol, IValidateEmailStore} from '@/pages/signUp/ValidateEmail'
import {IValidateOtpCodeStore} from '~/code/pages/signUp'

@injectable()
export class ValidateOtpCodeStore implements IValidateOtpCodeStore {
    validateEmailStore: IValidateEmailStore
    isLoading: boolean = false
    verificationId: string

    constructor(@inject(ValidateEmailStoreSymbol) validateEmailStore: IValidateEmailStore) {
        makeAutoObservable(this, {
            isLoading: observable,
            verificationId: observable,

            validateCode: action.bound
        })

        this.validateEmailStore = validateEmailStore
    }

    get email(): string {
        return this.validateEmailStore?.validEmail || storage.get(SIGNUP_STORAGE_KEYS.EMAIL) || ''
    }

    validateCode = async (code: string) => {
        try {
            this.isLoading = true
            const {result, error} = await validateEmailOtp(this.email, code)

            if (error) {
                openErrorNotification(error.message)
                return
            }

            if (result) {
                const verificationId = result.verificationId
                this.verificationId = verificationId
                storage.set(SIGNUP_STORAGE_KEYS.VERIFICATION_ID, verificationId)

                getRouterStore().push(ROUTES.signUpCreatePassword)
            }
        } catch (err) {
            error(err?.message || err)
        } finally {
            this.isLoading = false
        }
    }

    validateEmailPresence = () => {
        if (!Boolean(this.email)) {
            getRouterStore().push(ROUTES.signUpValidateEmail)
        }
    }

    resendCode = async () => {
        await this.validateEmailStore.validateEmail(this.email)
    }
}
